import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.scss';

const Button = (props) => {
  const { loadingMoreCards, onClick } = props;
  const text = loadingMoreCards ? i18next.t('Loading ...') : i18next.t('Load More Posts');

  return (
    <div className="df justify-center mt5 tc">
      <button
        type="button"
        onClick={onClick}
        className={classNames(
          'b-clear-blue founders-cond hover:bg-secondary hover:color-knockout-primary f4 ttu z-1',
          styles.loadMoreButton,
          {
            'bg-secondary color-knockout-primary': loadingMoreCards,
            'bg-knockout-primary color-secondary': !loadingMoreCards,
          },
        )}
      >
        {loadingMoreCards && <span className="icon icon-peacock mr2" />}
        {text}
      </button>
    </div>
  );
};

Button.propTypes = {
  loadingMoreCards: PropTypes.bool,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  loadingMoreCards: false,
  onClick: Function.prototype,
};

export default Button;
